<div class="ic-question">
  <div class="ic-question__header">
    @if (title) {
    <span class="ic-question__title">
      {{ title }}
    </span>
    }
  </div>
  <div class="ic-question__answer-body">
    <ng-content></ng-content>
  </div>
</div>
